import { useAuth } from "@clerk/react";
import { useQuery } from "@tanstack/react-query";
import { authFetch } from "@/lib/api";

export interface ClaimedAthlete {
  id: string;
  fullName: string;
  city: string | null;
  state: string | null;
  country: string | null;
  countryIso2: string | null;
  gender: string | null;
  mergedIntoId: string | null;
}

export interface UserAthleteProfile {
  id: string;
  userId: string;
  displayName: string | null;
  city: string | null;
  state: string | null;
  country: string | null;
  countryIso2: string | null;
  countryIso3: string | null;
  gender: string | null;
}

interface ProfileResponse {
  user: { id: string; clerkId: string; email: string; firstName: string | null; lastName: string | null };
  profile: UserAthleteProfile | null;
  claimedAthletes: ClaimedAthlete[];
}

export function useUserProfile() {
  const { isSignedIn, getToken } = useAuth();

  return useQuery({
    queryKey: ["user-profile"],
    queryFn: async () => {
      const token = await getToken();
      return authFetch<ProfileResponse>("/users/profile", { token });
    },
    enabled: !!isSignedIn,
    staleTime: 1000 * 60 * 2,
  });
}
